import { apiClient } from "../config";

interface ConfirmAccountRequest {
  userId: number | string;
}

interface ConfirmAccountResponse {
  message: string;
  data: {
    user_id: number;
  };
}

async function confirmAccount(userId: number | string): Promise<ConfirmAccountResponse> {
  const payload: ConfirmAccountRequest = {
    userId: userId
  };
  const res = await apiClient.put('/admin/users/confirm-user', payload);
  return res.data;
}

export default confirmAccount;